<template>
  <div class="relative min-h-screen">
    <!-- Background -->
    <div class="fixed inset-0 z-0 vault-gradient pointer-events-none"></div>

    <!-- Navbar -->
    <nav
      class="relative z-10 w-full px-6 lg:px-12 py-8 flex justify-between items-center"
    >
      <div class="flex items-center gap-3">
         <img src="/images/logo.png" style="height: 3.5rem;">
      </div>

      <a
        href="/login"
        class="text-sm font-semibold text-slate-600 hover:text-accent"
      >
        Back to Login
      </a>
    </nav>

    <!-- Main -->
    <main
      class="relative z-10 flex-1 flex flex-col items-center justify-center px-6 pb-20"
    >
      <div class="login-gate w-full max-w-md rounded-xl p-8 md:p-10">

        <!-- Request State -->
        <div v-if="!submitted" class="space-y-8">
          <div class="text-center space-y-3">
            <h1 class="text-3xl font-extrabold tracking-tight">
              Recover your vault key
            </h1>
            <p class="text-slate-500 text-sm">
              Enter the email associated with your account.
              We’ll send you a secure reset link.
            </p>
          </div>

          <!-- Email -->
          <div class="space-y-3">
            <label
              class="block text-[11px] font-bold uppercase tracking-widest text-slate-500 ml-1"
            >
              Email Address
            </label>
            <div class="relative group">
              <div
                class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-slate-400 group-focus-within:text-charcoal transition-colors"
              >
               <i class='bx bx-at text-xl'></i>
              </div>
              <input
                v-model="email"
                type="email"
                placeholder="you@vault.io"
                class="w-full bg-slate-50/50 border-slate-100 rounded-lg py-4 pl-12 pr-4 text-lg font-medium outline-none transition-all placeholder:text-slate-300 input-focus-effect"
              />
            </div>
          </div>

          <!-- Submit -->
          <!-- <button
            @click="submit"
            class="w-full bg-primary hover:bg-black text-white font-bold py-5 rounded-lg text-lg transition-all active:scale-[0.98]"
          >
            Send reset link
          </button> -->
          <button
            @click="submit"
            :disabled="loading"
            class="w-full bg-primary hover:bg-black text-white font-bold py-5 rounded-lg text-lg transition-all active:scale-[0.98] disabled:opacity-50"
          >
            <span v-if="!loading">Send reset link</span>
            <span v-else>Sending...</span>
          </button>

        </div>

        <!-- Success State -->
        <div v-else class="space-y-8 text-center">
          <div
            class="size-14 mx-auto bg-slate-100 rounded-full flex items-center justify-center text-primary"
          >
           <i class='bx bx-envelope text-2xl'></i>
          </div>

          <h2 class="text-2xl font-extrabold">
            Check your email
          </h2>

          <p class="text-slate-500 text-sm">
            If an account exists for <strong>{{ email }}</strong>,
            you’ll receive a password reset link shortly.
          </p>

          <a
            href="/login"
            class="inline-block text-sm font-bold text-accent hover:underline"
          >
            Return to login
          </a>
        </div>

      </div>

      <!-- Footer -->
      <footer
        class="absolute bottom-8 text-slate-400 text-[10px] uppercase tracking-[0.2em] font-bold"
      >
        Secure recovery • No access granted without verification
      </footer>
    </main>
  </div>
</template>
<script>
import { useToast } from "vue-toastification";
import { forgotPasswordApi } from "../apis/authapis";

export default {
  name: "ForgotPasswordScreen",

  data() {
    return {
      toast: useToast(),

      email: "",
      submitted: false,
      loading: false
    };
  },

  methods: {
    async submit() {

      // =========================
      // VALIDATIONS
      // =========================
      if (!this.email.trim()) {
        this.toast.error("Email is required");
        return;
      }

      // Email format check
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email)) {
        this.toast.error("Invalid email format");
        return;
      }

      this.loading = true;

      const res = await forgotPasswordApi(this.email);

      this.loading = false;

      // =========================
      // RESPONSE HANDLING
      // =========================
      if (!res.status) {
        this.toast.error(res.success || "Reset request failed");
        return;
      }

      this.toast.success(res.success || "Reset link sent");

      this.submitted = true;
    }
  }
};
</script>


